/** Cache regional article slugs so LanguageSwitcher can jump to the correct URL. */
const STORAGE_KEY = 'blogify:articleLocaleNav';

let cache = null;

function readStorage() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

function writeStorage(data) {
  try {
    if (data?.availableRegions) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    /* ignore quota / private mode */
  }
}

export function setArticleLocaleNavigation(data) {
  if (!data?.availableRegions) {
    cache = null;
    writeStorage(null);
    return;
  }
  cache = {
    availableRegions: data.availableRegions,
  };
  writeStorage(cache);
}

export function getRegionalArticleSlug(regionCode) {
  const code = String(regionCode || '').toUpperCase();
  if (!code) return null;

  const regions = cache?.availableRegions || readStorage()?.availableRegions;
  if (!regions) return null;
  return regions[code]?.slug || null;
}

export function clearArticleLocaleNavigation() {
  cache = null;
  writeStorage(null);
}
